export default "__VITE_ASSET__CMHEZIek__"